export const moduleName = 'gn.audio.public.hero-customizer-v2';
